import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// portal
import { environment } from '@open-portal-env';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const sessionToken = sessionStorage.getItem('sessionToken');
    if (request.url.indexOf(environment.apiEndpoint) > -1 && sessionToken) {
      const sessionRequest = request.clone({ setHeaders: { 'X-Session-Token': sessionToken } });
      return next.handle(sessionRequest).pipe(map((event: HttpEvent<any>) => {
        return this.setToken(event);
      }));
    } else {
      return next.handle(request).pipe(map((event: HttpEvent<any>) => {
        return this.setToken(event);
      }));
    }
  }

  setToken(event: HttpEvent<any>) {
    if (event instanceof HttpResponse) {
      if (event.headers.has('X-Session-Token')) {
        let session = event.headers.get('X-Session-Token');
        if (session) {
          sessionStorage.setItem('sessionToken', session);
        }
      }
    }
    return event;
  }
}
